<script setup lang="ts">
import JsonViewer from "@/components/ui/inputs/JsonViewer.vue";
import { useCompany } from "@/composables/models/company/useCompany";
import { computed } from "vue";
import { useRoute, useRouter } from "vue-router";
import { definePage } from "unplugin-vue-router/runtime";
import { useAbility } from "@casl/vue";
import PrimaryButton from "@/components/shared/buttons/PrimaryButton.vue";

definePage({
  meta: {
    title: "generic.action.viewEntity",
    titleParams: { entity: "generic.entity.orthoPcCompany" },
    checkPrivileges: () => {
      const { can } = useAbility();
      return can($permActions.READ, $permSubjects.PRACTICE__COMPANY);
    },
  },
});

const route = useRoute();
const router = useRouter();
const orthoPCCompanyId = computed(() => (route.params as { id: string }).id);
const { data: company } = useCompany({ id: orthoPCCompanyId });
</script>

<template>
  <div>
    <h1>Company</h1>
    <JsonViewer :data="company" />
    <PrimaryButton
      size="x-large"
      class="tw:!ml-4 tw:!mt-4"
      prepend-icon="mdi-pencil-outline"
      @click="router.push(`/companies/ortho-pc/${orthoPCCompanyId}/edit`)"
    >
      Edit
    </PrimaryButton>
  </div>
</template>

<style scoped></style>
